import React from "react";

import logo from "../../../svg/mohe-logo.svg";

const MoheLogo = () => {
  return (
    <div className="logo">
      <img src={logo} alt="وزارت تحصیلات عالی" />
    </div>
  );
};

export default MoheLogo;
